<div ngbDropdown container="body" *ngxPermissionsOnly="'planning.routes.update'">
  <button id="route-action-menu"
          appBringozIdGenerator="routeActionMenu"
          (click)="$event.stopPropagation();"
          ngbDropdownToggle>
    <bringoz-icon iconName="menu"></bringoz-icon>
  </button>
  <div ngbDropdownMenu aria-labelledby="route-action-menu">

    <ng-container *ngIf="route.agentReference">
      <button ngbDropdownItem
              appBringozIdGenerator="assignRouteOption"
              *ngxPermissionsOnly="'planning.routes.update'"
              [disabled]="!activeActionsMap.assign"
              (click)="onAssign.emit();$event.stopPropagation();">
        <div class="layout-row layout-align-start-center br-body-2">
          <bringoz-icon iconName="play-outline" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
          {{'Assign Route To' | translate}} {{route.agentReference | userName}}
        </div>
      </button>
    </ng-container>

    <button ngbDropdownItem
            appBringozIdGenerator="assignAndSelectRouteOption"
            *ngxPermissionsOnly="'planning.routes.update'"
            [disabled]="!activeActionsMap.assign"
            (click)="onAssignAndSelect.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="play-outline" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Assign And Select Driver' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="handleUnpackedOption"
            *ngxPermissionsOnly="'planning.routes.delete'"
            [disabled]="route.stats.notPacked < 1"
            (click)="onHandleUnpacked.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="cube" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Handle Unpacked Deliveries' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="reOptimizeOption"
            *ngxPermissionsOnly="'planning.routes.update'"
            [disabled]="!activeActionsMap.reOptimize"
            (click)="onReoptimize.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="reoptimize" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Re Optimize Route' | translate}}
      </div>
    </button>

    <ng-container *ngIf="!route.isBlockedByUser">
      <button ngbDropdownItem
              appBringozIdGenerator="lockRouteOption"
              [disabled]="!activeActionsMap.block"
              (click)="onBlock.emit();$event.stopPropagation();">
        <div class="layout-row layout-align-start-center br-body-2">
          <bringoz-icon iconName="lock-outline" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
          {{'Lock' | translate}}
        </div>
      </button>
    </ng-container>

    <ng-container *ngIf="route.isBlockedByUser">
      <button ngbDropdownItem
              appBringozIdGenerator="unlockRouteOption"
              [disabled]="!activeActionsMap.block"
              (click)="onUnblock.emit();$event.stopPropagation();">
        <div class="layout-row layout-align-start-center br-body-2">
          <bringoz-icon iconName="lock-open-outline" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
          {{'Unlock' | translate}}
        </div>
      </button>
    </ng-container>

    <button ngbDropdownItem
            appBringozIdGenerator="resetRouteOption"
            *ngxPermissionsOnly="'planning.routes.update'"
            [disabled]="!activeActionsMap.resetRoute"
            (click)="onReset.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="return" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Reset Route' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="updateRouteBranchesOption"
            *ngxPermissionsOnly="'planning.routes.update'"
            [disabled]="!activeActionsMap.updateBranches"
            (click)="onUpdateBranches.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="branch" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Update Branches' | translate}}
      </div>
    </button>


    <button ngbDropdownItem
            appBringozIdGenerator="updateResourceOption"
            *ngxPermissionsOnly="'planning.routes.update'"
            [disabled]="!activeActionsMap.updateResource"
            (click)="onUpdateResource.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="edit" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Update Resource' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="updateLogisticsOption"
            *ngxPermissionsOnly="'vehicleInstance.logisticsVehicle.update'"
            [disabled]="!activeActionsMap.updateLogisticVehicle"
            (click)="onUpdateLogisticsVehicle.emit(bindingTask);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="edit" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Update logistics vehicle' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="manageAssistantsOption"
            *ngxPermissionsOnly="'planning.routes.update'"
            [disabled]="!activeActionsMap.manageAssistants"
            (click)="onManageAssistants.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="assistant" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Manage Assistants' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="printOption"
            [disabled]="!activeActionsMap.printRoute"
            (click)="onPrint.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="print-outline" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Print' | translate}}
      </div>
    </button>


    <button ngbDropdownItem
            appBringozIdGenerator="printLoadingSheetOption"
            [disabled]="!activeActionsMap.printLoadingSheet"
            (click)="onPrintLoadingSheet.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="print-outline" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Print Loading Sheet' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="printBillOfLadingOption"
            [disabled]="!activeActionsMap.printBillOfLading"
            (click)="onPrintBillOfLading.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="print-outline" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Print Bill of Lading' | translate}}
      </div>
    </button>

    <ng-container *ngIf="activeActionsMap.printIkea">
      <button ngbDropdownItem
              appBringozIdGenerator="printIkeaOption"
              (click)="onPrintIkea.emit();$event.stopPropagation();">
        <div class="layout-row layout-align-start-center br-body-2">
          <bringoz-icon iconName="print" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
          {{'Print Ikea' | translate}}
        </div>
      </button>
    </ng-container>

    <button ngbDropdownItem
            appBringozIdGenerator="DownloadBillOfLadingOption"
            [disabled]="!activeActionsMap.downloadBillOfLading"
            (click)="onDownloadBillOfLading.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="download" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Download Bill of Lading' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            appBringozIdGenerator="exportOption"
            (click)="onExport.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="export" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Export' | translate}}
      </div>
    </button>

    <button ngbDropdownItem
            *ngxPermissionsOnly="'planning.routes.update'"
            appBringozIdGenerator="changeRouteColorOption"
            (click)="onChangeRouteColor.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="edit" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{"Change route's color" | translate}}
      </div>
    </button>


    <button ngbDropdownItem
            *ngxPermissionsOnly="'planning.routes.delete'"
            appBringozIdGenerator="deleteRouteOption"
            [disabled]="!activeActionsMap.removeRoute"
            (click)="onRemove.emit();$event.stopPropagation();">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="trash" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
        {{'Delete Route' | translate}}
      </div>
    </button>

  </div>
</div>
